import {Condition, LocalizedString, TemplateValue} from '../types';

export const template = <T extends string | LocalizedString>($template: T) =>
  ({$template}) as const satisfies TemplateValue;

export const formatAsCurrency = (field: string): TemplateValue => ({
  $template: `\${currency(${field})}`,
});

export const buildAmountOrPercentageTemplateValue = (field: string, isAmount: Condition) => {
  const fieldAsArray = field.asIndex();

  return {
    $switch: [
      {$case: [isAmount], $then: {$template: `\${currency(${fieldAsArray})}`}},
      {$default: {$template: `\${percentage(${fieldAsArray})}`}},
    ],
  };
};
